import { AxiosPromise } from 'axios';
import { IGetCopiableCourses, IGetSemesterActivities, ISemesterActivityReq } from '../models/evaluationSemesterSeq.model';
import axios from 'axios';

const uri = '/mgmt/evaluation/semester-seq';

// 평가 차시 - 일부 조회
export const getSemesterActivities = (semesterCourseCode: string, timeTableSeq: number): AxiosPromise<IGetSemesterActivities> => {
  return axios.get(`${uri}/${semesterCourseCode}/${timeTableSeq}`);
}

// 평가 차시 - 전체 조회
export const getAllSemesterActivities = (semesterCourseCode: string): AxiosPromise<IGetSemesterActivities> => {
  return axios.get(`${uri}/${semesterCourseCode}`);
}

export const createSemesterActivities = (semesterCourseCode: string, timetableSeq: number, data: ISemesterActivityReq): AxiosPromise => {
  return axios.post(`${uri}/${semesterCourseCode}/${timetableSeq}`, data);
};

export const deleteSemesterActivity = (semesterSeqEvaluationCode: number): AxiosPromise => {
  return axios.delete(`${uri}/${semesterSeqEvaluationCode}`);
};

// 평가 차시 - 복사용 과정목록 조회
export const getCopiableCourses = (semesterCourseCode: string): AxiosPromise<IGetCopiableCourses> => {
  return axios.get(`${uri}/copy/${semesterCourseCode}`);
}

// 평가 차시 - 복사
export const copyCourseItems = (semesterCourseCode: string, targetSemesterCourseCode: string): AxiosPromise => {
  return axios.post(`${uri}/copy/${semesterCourseCode}/${targetSemesterCourseCode}`);
}
